
import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";

interface CustomerListProps {
  data: any[];
}

export function CustomerList({ data }: CustomerListProps) {
  const [period, setPeriod] = useState("all");

  const getCustomerStatus = (customer: any) => {
    const hasOverdue = customer.transactions?.some(
      (t: any) => t.payment_status === "atrasado"
    );
    if (hasOverdue) return "Inadimplente";

    const lastTransaction = customer.transactions?.sort(
      (a: any, b: any) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0];

    if (
      lastTransaction &&
      new Date(lastTransaction.created_at) >
        new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
    ) {
      return "Ativo";
    }

    return "Inativo";
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Ativo":
        return "text-green-600";
      case "Inativo":
        return "text-gray-600";
      case "Inadimplente":
        return "text-red-600";
      default:
        return "";
    }
  };

  const getTotalSpent = (customer: any) => {
    return customer.transactions?.reduce(
      (sum: number, transaction: any) =>
        transaction.type === "entrada" ? sum + Number(transaction.amount) : sum,
      0
    );
  };

  const getLastPurchase = (customer: any) => {
    const lastTransaction = customer.transactions?.sort(
      (a: any, b: any) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0];
    return lastTransaction ? format(new Date(lastTransaction.created_at), "dd/MM/yyyy") : "-";
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Total Gasto</TableHead>
            <TableHead>Última Compra</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((customer) => {
            const status = getCustomerStatus(customer);
            return (
              <TableRow key={customer.id}>
                <TableCell className="font-medium">{customer.name}</TableCell>
                <TableCell>
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(getTotalSpent(customer))}
                </TableCell>
                <TableCell>{getLastPurchase(customer)}</TableCell>
                <TableCell className={getStatusColor(status)}>
                  {status}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
